import {type App, ref} from "vue";
import log from "../log/index.js";

export interface ReqCallback {
  (ok : boolean):void
}

const Msg = {
  serverError : "C'è stato un errore e non è stato possibile completare la richiesta",
  permissionError : "Non hai i permessi per effettuare questa richiesta"
}

class Messages {
  loadingDialog = ref(false)
  loadingMessage = ref('loading...')
  messageDialog = ref(false)
  alertDialog = ref(false)
  confirmDialog = ref(false)
  messageColor = ref('info')
  title = ref("Richiesta conferma")
  message = ref("Sei sicuro?")
  checkbox = ref<boolean|string>("Definitivamente")
  checkboxValue = ref(false)
  callback = ref<ReqCallback>((ok:boolean)=>{log.d("confirm",ok)})

  requestConfirm(title:string, message:string, checkbox:boolean|string, callback : ReqCallback) {
    this.title.value = title;
    this.message.value = message;
    this.checkbox.value = checkbox;
    this.callback.value = callback;
    this.confirmDialog.value = true
  }


  alert(title:string, message:string) {
    this.title.value = title;
    this.message.value = message;
    this.alertDialog.value = true
  }

  error(message:string) {
    this.message.value = message;
    this.messageColor.value = 'error';
    this.messageDialog.value = true;
  }
  warn(message:string) {
    this.message.value = message;
    this.messageColor.value = 'warn';
    this.messageDialog.value = true;
  }
  info(message:string) {
    this.message.value = message;
    this.messageColor.value = 'info';
    this.messageDialog.value = true;
  }
  success(message:string) {
    this.message.value = message;
    this.messageColor.value = 'success';
    this.messageDialog.value = true;
  }

}


export default {
  install: (app:App) => {

    const messages = new Messages()


    app.provide<Messages>('messages', messages)
  },
};

export {Messages, Msg}
